import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataControl = _resolveComponent("DataControl")!
  const _component_TabControl = _resolveComponent("TabControl")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_n_layout_header = _resolveComponent("n-layout-header")!
  const _component_AppUpdatePrompt = _resolveComponent("AppUpdatePrompt")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_n_layout_content = _resolveComponent("n-layout-content")!
  const _component_n_layout = _resolveComponent("n-layout")!
  const _component_NaiveProvider = _resolveComponent("NaiveProvider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataControl),
    _createVNode(_component_TabControl),
    _createVNode(_component_NaiveProvider, null, {
      default: _withCtx(() => [
        _createVNode(_component_n_layout, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_layout_header, { bordered: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_NavBar)
              ]),
              _: 1
            }),
            _createVNode(_component_n_layout_content, { "content-style": "padding: 24px;" }, {
              default: _withCtx(() => [
                _createVNode(_component_AppUpdatePrompt),
                _createVNode(_component_router_view)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}